export enum RaceRegistrationStatusEnum {
    AVAILABLE_SOON = 'available_soon',
    CHARITY_BIBS_AVAILABLE = 'charity_bibs_available',
    REGISTRATION_CLOSED = 'registration_closed',
    REGISTRATION_OPEN = 'registration_open',
    SOLD_OUT = 'registration_sold_out',
}
